import { styled } from '@mui/material';
import type { Order } from '@partful/shared-types';
import { useEffect, useState } from 'react';
import { Margin, usePDF } from 'react-to-pdf';
import { ExportButtonBase, ExportButtonProps } from './ExportButton';
import { ExportPdfOrderDetails } from './ReceivedOrdersPage/ReceivedOrdersTable/ExportPdfOrderDetails';

export function ExportPdfButton({
  order,
  label,
  icon,
  ...buttonProps
}: Omit<ExportButtonProps, 'orderMarkup' | 'type'> & { order: Order }) {
  const page = {
    margin: Margin.SMALL,
  };

  const filename = order.eCommerceOrderName || order.orderId;
  const { toPDF, targetRef } = usePDF({ filename, page });
  const [displayOrder, setDisplayOrder] = useState(false);

  const exportPdf = /* istanbul ignore next */ () => {
    setDisplayOrder(true);
  };

  // Display it conditionally only when needed for print to avoid polluting the DOM
  useEffect(() => {
    /* istanbul ignore next */
    if (displayOrder) {
      toPDF();
      setDisplayOrder(false);
    }
  }, [displayOrder]); // eslint-disable-line react-hooks/exhaustive-deps

  const orderMarkup = displayOrder ? (
    /* istanbul ignore next */
    <OrderPrintPage ref={targetRef}>
      <ExportPdfOrderDetails order={order} />
    </OrderPrintPage>
  ) : undefined;

  return (
    <ExportButtonBase
      {...buttonProps}
      onClick={exportPdf}
      label={label}
      orderMarkup={orderMarkup}
      type="pdf"
      icon={icon}
    />
  );
}

const OrderPrintPage = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Display it outside viewport */
  position: absolute;
  left: -9999px;
  top: -9999px;
`;
